export function auditTabs() {
	const section = document.querySelector('.audit-tabs');
	if (!section) return;

	const tabs = section.querySelectorAll('.tab');
	const contents = section.querySelectorAll('.audit-tabs__content');
	if (!tabs.length || !contents.length) return;

	tabs.forEach((tab) => {
		tab.addEventListener('click', () => {
			const targetId = tab.getAttribute('data-tab');
			if (!targetId) return;

			// Deactivate all tabs
			tabs.forEach((t) => t.classList.remove('is-active'));
			// Deactivate all content panels
			contents.forEach((c) => c.classList.remove('is-active'));

			// Activate clicked tab
			tab.classList.add('is-active');

			// Activate matching content
			const targetContent = section.querySelector(`[data-tab-content="${targetId}"]`);
			if (targetContent) {
				targetContent.classList.add('is-active');
			}
		});
	});
}
